import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PaginatorModule } from '@openng/optimus-ui/paginator';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { PaginatorState } from '@openng/optimus-ui/paginator'
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { CampaignService } from '../../../services/campaign.service';
import { ToastBarService } from "../../../services/toast-bar.service";
import { NgForOf, NgIf } from '@angular/common';
import { ICampaign } from '../../../models/campaign/campaign.interface';
import { RouterLink } from '@angular/router';
import { TemplateService } from '../../../services/template.service';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { ConfirmationService, MessageService } from '@openng/optimus-ui/api';
import { SignalRService } from '../../../services/signalr.service';
import { TooltipModule } from "@openng/optimus-ui/tooltip";
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-list-campaign',
  imports: [
    PaginatorModule,
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    RouterLink,
    DialogModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  templateUrl: './list-campaign.component.html',
  styleUrl: './list-campaign.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ConfirmationService, MessageService]
})
export class ListCampaignComponent implements OnInit {
  loading = false;

  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;   // ukupan broj zapisa

  campaigns: ICampaign[] = [];
  searchControl = new FormControl('');

  constructor(protected campaignService: CampaignService,
              protected templateService: TemplateService,
              protected toastBarService: ToastBarService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService,
              private signalRService: SignalRService) {
  }


  ngOnInit(): void {
    this.loadCampaigns();

    // Set total count
    this.campaignService.getCampaignTotalCount().subscribe({
      next: (totalCountResponse: number) => {
        this.totalRecords = totalCountResponse;
      },
      error: (err: HttpErrorResponse) => {
        console.error("Something went wrong while fetching total campaign count!", err);
        this.toastBarService.showToastError("Something went wrong while fetching total campaign count!");
      }
    })

    // Search sa debounce
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.first = 0; // resetiraj na prvu stranicu kad se pretražuje
        this.loadCampaigns();
      });

    // Check for campaign deletion process
    this.signalRService.campaignDeletionListener(
      (campaignName: string, isDeleted: boolean) => {
        if (isDeleted) {
          this.spliceCampaignFromList(campaignName);
          this.toastBarService.showToastSuccess(`Campaign ${campaignName} deleted successfully.`);
        } else {
          this.toastBarService.showToastError(`Campaign ${campaignName} wasn't deleted successfully.`);
        }
      }
    );
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? 10;
    this.loadCampaigns();
  }

  protected loadCampaigns(): void {
    this.loading = true;

    let params: { first: number, rows: number, search?: string } = {
      first: this.first,
      rows: this.rows,
    }
    const search = this.searchControl.value ?? '';
    if (search) {
      params.search = search;
    }

    this.campaignService.getCampaignList(params).subscribe({
      next: (res: any) => {
        console.log("RES---->", res)
        this.campaigns = res;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error loading campaigns', err);
        this.loading = false;
      }
    });
  }

  deleteCampaign(campaignName: string) {
    let campaignIndex = this.campaigns.findIndex(c => c.campaignName === campaignName);
    this.campaigns[campaignIndex].isInProgress = true;

    this.campaignService.deleteCampaign(campaignName).subscribe({
      next: (res: any) => {
        this.toastBarService.showToastSuccess("Campaign deletion job accepted!");
      },
      error: (err: any) => {
        console.error('Error delete campaign', err);
      }
    });
  }

  private spliceCampaignFromList(campaignName: string) {
    const campaignIndex = this.campaigns.findIndex(c => c.campaignName === campaignName);
    this.campaigns.splice(campaignIndex, 1);
  }

  deleteCampaignDialog(event: Event, campaignName: string) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to delete this campaign?\n\nNOTE: This will delete all of the templates that belong to it as well!',
      header: `Delete ${campaignName}?`,
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Record deleted'});
        this.deleteCampaign(campaignName);
      },
      reject: () => {
        this.messageService.add({severity: 'error', summary: 'Rejected', detail: 'You have rejected'});
      }
    });
  }

}
